<template>
  <div>
    <div class="animated fadeIn">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    </div>
    <b-card header="Pacotes disponíveis" v-if="items.length > 0">
      <b-row>
        <b-col xl="4" lg="4" md="6" sm="12" v-for="(item, index) in items">
          <b-card
            border-variant="primary"
            header-bg-variant="primary"
            header-text-variant="white"
            align="center"
          >
            <template slot="header">
              <h4>
                <strong>R${{item.valor}}</strong>
              </h4>
            </template>
            <span>
              Neste pacote contem
              <strong>{{item.quantidade}}</strong> pushs.
            </span>
            <template slot="footer">
              <form
                :id="index"
                action="http://localhost:50130/gerencial/recebe-pagamento"
                method="POST"
              ></form>
            </template>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-else-if="items.length = 0 && !isLoading">
      <h3 class="f-g text-center">Não achamos pacotes no momento</h3>
    </b-card>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";
import { METHODS } from "http";

export default {
  name: "pacotes",
  components: {
    Loading
  },
  data: () => {
    return {
      items: [],
      isLoading: false
    };
  },

  async beforeMount() {
    this.isLoading = true;
    await axios
      .get(
        `${
          config.default.servidor
        }/gerencial/retorna-pacotes-vigentes/${localStorage
          .getItem("enterprise_id")
          .toString()}`,
        {
          headers: {
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(async response => {
        if (response.status == 200) {
          if (response.data) {
            this.items = response.data.pacotes.pushs;
            if (this.items.length > 0) {
              for (let i = 0; i < this.items.length; i++) {
                const e = this.items[i];
                var script = document.createElement("script");
                script.setAttribute(
                  "src",
                  "https://www.mercadopago.com.br/integrations/v1/web-tokenize-checkout.js"
                );

                script.setAttribute(
                  "data-public-key",
                  "TEST-098e544c-a975-4895-bf2d-250563e4cf7b"
                );

                script.setAttribute("data-transaction-amount", `${e.valor}`);

                script.setAttribute("data-button-label", "Adquirir");

                var inputValor = document.createElement('input');
                inputValor.name = "valor";
                inputValor.setAttribute('value',`${e.valor}`);
                inputValor.setAttribute('hidden','true');

                var inputQtd = document.createElement('input');
                inputQtd.name = "qtdPushs";
                inputQtd.setAttribute('value',`${e.quantidade}`);
                inputQtd.setAttribute('hidden','true');

                var threshold = 0;

                for (let j = 0; threshold < 5; j++) {
                  try {
                    this.montarForm(`${i.toString()}`, script, inputValor, inputQtd);

                    break;
                  } catch (_) {
                    await setTimeout(
                      _ => {
                        threshold++;
                      },
                      threshold + 1 * 20 //Tempo de espera
                    );
                  }
                }
              }
            }
          }
        }
      })
      .catch(error => {
        this.$dialogs.alert(`Algo deu errado.`);
      });
    this.isLoading = false;
  },

  methods: {
    redirecionar() {
      this.$router.push("/pacotes/adquirir-pacotes");
    },
    montarForm(id, script, inputValor, inputQtd) {
      document.getElementById(id).appendChild(script);
      document.getElementById(id).appendChild(inputValor);
      document.getElementById(id).appendChild(inputQtd);
    }
  }
};
</script>

